import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
/* eslint-disable prettier/prettier */

import React, { Component } from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { storeArq } from 'correos-arq-utils';
;
;

var BreadCrumb = /*#__PURE__*/function (_Component) {
  _inherits(BreadCrumb, _Component);

  var _super = _createSuper(BreadCrumb);

  function BreadCrumb(props) {
    var _this;

    _classCallCheck(this, BreadCrumb);

    _this = _super.call(this, props); // Crear o modificar objeto que controla el MLateral
    // segun la URL en la que nos encontramos

    _this.cambiarSubMenu = function (key) {
      var newSubMenu = {};
      var acciones = _this.state.auth.userInfo.accionesWeb;
      var parent = acciones.filter(function (items) {
        return items.path === key;
      });
      newSubMenu = {
        childs: acciones.filter(function (items) {
          return items.path === key;
        }).filter(function (items) {
          return items.sub !== null;
        }).map(function (items) {
          return items.sub;
        })[0],
        parent: parent.length > 0 ? parent[0].path : ''
      }; // se carga el storeArq en el componente

      storeArq.load(); // @ts-ignore: Guardar los datos en el storeArq

      storeArq.data.auth.userInfo.subMenu = newSubMenu;
      storeArq.save();

      _this.props.reloadApp();
    }; // Actualizar estado para renderizar el componente


    _this.refreshURL = function () {
      _this.setState({
        url: window.location.pathname
      });
    };

    _this.state = {
      migas: [{
        path: '/',
        label: 'router_routes.home'
      }],
      mounted: false,
      url: window.location.pathname,
      auth: storeArq.data.auth
    };
    return _this;
  }

  _createClass(BreadCrumb, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Cambiar estado al montar para lanzar componentDidUpdate y render
      this.setState({
        mounted: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState, _snapshot) {
      var _this2 = this;

      var url = window.location.pathname;
      var migas = [{
        path: '/',
        label: 'router_routes.home'
      }];

      var _loop = function _loop(i) {
        var path = '/' + url.split('/').slice(1, i + 1).join('/');

        var label = _this2.props.routes.filter(function (items) {
          return items.path === path && items.path !== '/';
        }).map(function (rutas) {
          return rutas.label;
        })[0];

        migas.push({
          path: path,
          label: label
        });
      };

      for (var i = 1; i < url.split('/').length; i++) {
        _loop(i);
      }

      if (prevState.migas.slice(-1)[0].path !== migas.slice(-1)[0].path) {
        this.cambiarSubMenu(migas.slice(1)[0].path);
        this.setState({
          migas: migas
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var props = this.props;
      storeArq.load();
      return /*#__PURE__*/React.createElement("div", {
        className: "BreadCrumbs"
      }, /*#__PURE__*/React.createElement(Breadcrumb, {
        className: "Bread"
      }, this.state.migas.map(function (itemsMigas, i) {
        return /*#__PURE__*/React.createElement(Breadcrumb.Item, {
          key: i
        }, /*#__PURE__*/React.createElement(Link, {
          to: itemsMigas.path,
          onClick: function onClick() {
            _this3.refreshURL();

            props.clickMenu && props.clickMenu();

            if (itemsMigas.path === '/') {
              props.clickHome(true); // @ts-ignore

              storeArq.data.auth.userInfo.subMenu = {};
              storeArq.save();
            }
          }
        }, props.t(itemsMigas.label)));
      })));
    }
  }]);

  return BreadCrumb;
}(Component);

export default withTranslation()(BreadCrumb);